export default {"src":"/uk/_next/static/media/close.784b90d3.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};